<template>
    <div class="functional_region" :style="{'height': `calc(100% - ${(parseInt(allUsers.length / 2)?parseInt(allUsers.length / 2) : 1)  * 80 + 5}px)`}" >
        <!-- <ChatArea
        v-show="fun_tab_active == '消息'"
        :msgs="msgs"
        parentDOM="teacher"
        :userId="userLogin.userId"
        :imMsg="imMsg"
        ></ChatArea> -->
        <div class="chatArea">
            <ul id="msg_box" class="im-log-box">
                <el-row type="flex" justify="center" v-if="!isCompleted">
                    <el-button type="text" @click="viewMoreMsg">查看更多</el-button>
                </el-row>
                <template v-for="(msg, index) in msgs">
                    <li
                     v-if="msg.payload.description && msg.payload.description != 'fn'"
                     :class="classData.userId == msg.from? 'my' : ''"
                     :key="index">
                        <!-- <span class="send">{{msg.time}}</span> -->
                        <span class="send">{{msg.payload.extension}}</span>
                        <div class="content">
                            <span :class="classData.userId == msg.from? 'mytriangleIcon' : 'triangleIcon'" class=""></span>
                            <div :class="classData.userId == msg.from? 'contentBox' : 'myContent contentBox'">
                                {{ msg.payload.description == 'text'? msg.payload.data : '' }}
                                <img class="emojiImg" v-if="msg.payload.description == 'emoji'" :src="`${emojiIcon[msg.payload.data].img}`">
                                <div v-if="msg.payload.description == 'img'" class="demo-image__preview">
                                    <el-image 
                                    style="width: 100px; height: 100px"
                                    :src="msg.payload.data" 
                                    :preview-src-list="[msg.payload.data]">
                                    </el-image>
                                </div>
                                <div v-if="msg.payload.description == 'file'">
                                    <el-link
                                    @click="downloadFile(msg.payload.data)"
                                    type="primary">{{ msg.payload.data.split('/name+')[1] }}</el-link>
                                </div>
                                <div
                                :class="classData.userId == msg.from? 'voiceIconImg my' : 'voiceIconImg'"
                                v-if="msg.payload.description == 'voice'"
                                @click="handlerVoice(`voice${index}`)">
                                    <img style="height: 100%" :src="voiceIcon[2]">
                                    {{ `${msg.payload.data.split('/time+')[1]}\"` }}
                                </div>
                                <audio
                                :ref="`voice${index}`"
                                v-if="msg.payload.description == 'voice'" 
                                style="width: 10px;" 
                                :src="`${msg.payload.data.split('/time+')[0]}`"></audio>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <!-- <div class="commonBox" v-show="commonBoxShow">
                <el-input v-model="content" @keyup.enter.native="onSendMsg" placeholder="消息内容"></el-input>    
                <el-button type="primary" @click="onSendMsg">发送</el-button>
            </div> -->
        </div>
        <div class="functional_region_foot_tab">
            <div class="flex_row">
                <!-- <span class="keyboardIcon" @click="input_speak = 'input'"></span> -->
                <Emoji :enableChat="enableChat" @sendEmojiMessage="sendEmojiMessage"></Emoji>
                <el-tooltip content="发送语音（按住说话，松开发送）" placement="top" effect="light">
                    <span
                        class="voiceIcon"
                        @mousedown.left="handlerVoicePlay"
                        @mouseup.left="handlerVoiceStop"
                        @mouseout="handlerVoiceStop"></span>
                </el-tooltip>
                <PicUpload :enableChat="enableChat" @imgUploadSuccess="imgUploadSuccess"></PicUpload>
            </div>
            <div class="hands_btn_box">
                <div class="hands_btn" @click="raiseHand">
                    <el-tooltip content="举手上台" placement="top" effect="light">
                        <img src="@/assets/tic/stuhand.png" alt="">
                    </el-tooltip> 
                </div>
            </div>
        </div>
        <div v-if="input_speak == 'speak'">
            <SpeakLoading :isplay="speckLoadingPlay"></SpeakLoading>
        </div>
        <div class="commonBox" v-if="input_speak == 'input'">
            <el-input
                type="textarea"
                rows="2"
                :placeholder="enableChat? '请输入内容' : '当前禁言'"
                v-model="msgContent"
                resize="none"
                maxlength="50"
                :disabled="!enableChat"
                @keydown.enter.native="sendTextMsg">
            </el-input>
            <el-button :disabled="!enableChat" type="primary" @click="sendTextMsg">发送</el-button>
        </div>
        <CardAnimation ref="cardAnimationRef" :img="awardCardImg"></CardAnimation>
    </div>
</template>
<script>
import TIM from 'tim-js-sdk';
import TIMUploadPlugin from 'tim-upload-plugin';
import emoji from './emoji.js';
import Emoji from "./emoji.vue";
import PicUpload from "./picUpload";
import FileUpload from "./fileUpload";
import fileApi from '@/request/api/file';
import classApi from '@/request/api/class';
import Recorder from 'js-audio-recorder';
import tencentApi from '@/request/api/tencent';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import SpeakLoading from './speakLoading.vue';
import CardAnimation from './cardAnimation';
export default {
    props: ['userId', 'parentDOM', 'handlerStuSaveWorksFn', "stuLoadWork", "enableChat", "changeTab", "stopClass"],
    computed: {
        ...mapGetters(["classData", "allUsers", "tecLookWork", "userMe"])
    },
    components: {
        Emoji,
        PicUpload,
        FileUpload,
        SpeakLoading,
        CardAnimation
    },
    data() {
        return {
            chatSwitch: true,
            msgContent: "",
            options: {
                SDKAppID: this.institutionConfig.tencentTrtcAppId // 接入时需要将 0 替换为您的云通信应用的 SDKAppID
            },
            emojiIcon: emoji,
            voiceIcon: [require('@/assets/tic/voice1.png'), require('@/assets/tic/voice2.png'), require('@/assets/tic/voice3.png')],
            msgs: [],
            isCompleted: false, //是否拉去到全部消息
            nextReqMessageID: "", //拉去下次校区列表消息ID
            input_speak: 'input',
            speckLoadingPlay: false,
            recorder: new Recorder(),
            awardCardImg: "", //奖励卡片url
            voiceTime: 0,
            voiceUrl: "",
        }
    },
    watch: {
        msgs() {
            console.log(this.msgs)
        },
        'classData.userId'() {
            console.log(111111111)
            
        },
    },
    created() {
        this.tim = TIM.create(this.options)
        console.log(this.msgs)
        // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
        this.tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
        // tim.setLogLevel(1); // release级别，SDK 输出关键信息，生产环境时建议使用
        // 注册腾讯云即时通信 IM 上传插件，即时通信 IM SDK 发送图片、语音、视频、文件等消息需要使用上传插件，将文件上传到腾讯云对象存储
        this.tim.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});
        this.addTICMessageListener();
        console.log(this.classData)
        this.loginPromise = this.tim.login({userID: this.classData.userId, userSig: this.classData.userSig})
        this.loginPromise.then(this.loginSuccess)
        this.loginPromise.catch(this.loginCatch)
        this.setFileMessage(this.fileUploadSuccess)
        this.setDefinedMsg(this.definedMsgFN)
    },
    methods: {
        ...mapMutations(["setClassData", "setFileMessage", "setTecLookWork", "setDefinedMsg"]),
        ...mapActions(["changeMicMute", "changeCamMute"]),
        //登录成功
        loginSuccess(imResponse) {
            console.log(imResponse)
            
        },
        //登录失败
        loginCatch(imError) {
            console.log(imError)
        },
        //创建群
        createGroup() {
            console.log(this.classData.channelId)
            let groupPromise = this.tim.createGroup({
                type: TIM.TYPES.GRP_MEETING,
                name: 'WebSDK',
                groupID: this.classData.channelId
            })
            groupPromise.then((imResponse) => { // 创建成功
                console.log(imResponse.data.group); // 创建的群的资料
                this.joinGroup();
            })
            groupPromise.catch((imError) => {
                console.warn('createGroup error:', imError); // 创建群组失败的相关信息
            });
        },
        //查询群
        searchGroupByID() {
            let promise = this.tim.searchGroupByID(this.classData.channelId);
            promise.then((imResponse) => {
                console.log(imResponse)
                const group = imResponse.data.group; // 群组信息
                this.joinGroup();
            }).catch((imError) => {
                console.warn('searchGroupByID error:', imError); // 搜素群组失败的相关信息
                this.createGroup();
            });
        },
        joinGroup() {
            let promise = this.tim.joinGroup({ groupID: this.classData.channelId, type: TIM.TYPES.GRP_MEETING });
            promise.then((imResponse) => {
                console.log(imResponse)
                switch (imResponse.data.status) {
                    case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
                        break;
                    case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                        this.getMessageList();
                    console.log(imResponse.data.group); // 加入的群组资料
                        break;
                    case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                        this.getMessageList();
                        break;
                    default:
                        break;
                }
            }).catch(function(imError){
                console.warn('joinGroup error:', imError); // 申请加群失败的相关信息
            });
        },
        //奖励动画显示
        studentAnimation(url) {
            this.awardCardImg = url;
            this.$refs.cardAnimationRef.show();
        },
        allMicMute(value) {
            console.log(value, '11111111111111111111')
            let bool = JSON.parse(value);
            console.log(this.userMe, bool)
            if(this.userMe.audioMuted != bool) {
                this.changeMicMute();
            }
        },
        addTICMessageListener() {
            this.tim.on(TIM.EVENT.SDK_READY, (event) => {
                // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
                // event.name - TIM.EVENT.SDK_READY
                console.log('SDK_READY')
                this.searchGroupByID();
            });

            this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, (event) => {
                // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
                // event.name - TIM.EVENT.MESSAGE_RECEIVED
                // event.data - 存储 Message 对象的数组 - [Message]
                console.log(event)
                event.data.forEach((item, index) => {
                    if(item.payload.description == 'fn' ) {
                        let { data, extension } = item.payload;
                        this.$emit(data, extension, item.from)
                        this[data](extension, item.from);
                        return;
                    }
                    this.msgs.push(item)
                    this.$nextTick(() => {
                        document.getElementById('msg_box').scrollTop = document.getElementById('msg_box').scrollHeight;
                    })
                })
            });

            this.tim.on(TIM.EVENT.MESSAGE_REVOKED, function(event) {
                // 收到消息被撤回的通知。使用前需要将SDK版本升级至v2.4.0或更高版本。
                // event.name - TIM.EVENT.MESSAGE_REVOKED
                // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isRevoked 属性值为 true
            });

            this.tim.on(TIM.EVENT.MESSAGE_READ_BY_PEER, function(event) {
                // SDK 收到对端已读消息的通知，即已读回执。使用前需要将SDK版本升级至v2.7.0或更高版本。仅支持单聊会话。
                // event.name - TIM.EVENT.MESSAGE_READ_BY_PEER
                // event.data - event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isPeerRead 属性值为 true
            });

            this.tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function(event) {
                // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
                // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
                // event.data - 存储 Conversation 对象的数组 - [Conversation]
            });

            this.tim.on(TIM.EVENT.GROUP_LIST_UPDATED, function(event) {
                // 收到群组列表更新通知，可通过遍历 event.data 获取群组列表数据并渲染到页面
                // event.name - TIM.EVENT.GROUP_LIST_UPDATED
                // event.data - 存储 Group 对象的数组 - [Group]
            });

            this.tim.on(TIM.EVENT.PROFILE_UPDATED, function(event) {
                // 收到自己或好友的资料变更通知
                // event.name - TIM.EVENT.PROFILE_UPDATED
                // event.data - 存储 Profile 对象的数组 - [Profile]
            });

            this.tim.on(TIM.EVENT.BLACKLIST_UPDATED, function(event) {
                // 收到黑名单列表更新通知
                // event.name - TIM.EVENT.BLACKLIST_UPDATED
                // event.data - 存储 userID 的数组 - [userID]
            });

            this.tim.on(TIM.EVENT.ERROR, function(event) {
                // 收到 SDK 发生错误通知，可以获取错误码和错误信息
                // event.name - TIM.EVENT.ERROR
                // event.data.code - 错误码
                // event.data.message - 错误信息
            });

            this.tim.on(TIM.EVENT.SDK_NOT_READY, function(event) {
                // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
                // event.name - TIM.EVENT.SDK_NOT_READY
            });

            this.tim.on(TIM.EVENT.KICKED_OUT, function(event) {
                // 收到被踢下线通知
                // event.name - TIM.EVENT.KICKED_OUT
                // event.data.type - 被踢下线的原因，例如 :
                //   - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
                //   - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
                //   - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢（v2.4.0起支持）。
            });

            this.tim.on(TIM.EVENT.NET_STATE_CHANGE, function(event) {
                // 网络状态发生改变（v2.5.0 起支持）。
                // event.name - TIM.EVENT.NET_STATE_CHANGE
                // event.data.state 当前网络状态，枚举值及说明如下：
                //   - TIM.TYPES.NET_STATE_CONNECTED - 已接入网络
                //   - TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
                //   - TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
            });
        },
        //处理自定义消息
        dealDirectiveMsg(msg) {
            console.log(msg)
            let { data } = msg.payload;
            let arr = data.split('#');
            console.log(arr)
            // if(this[arr[2]]) {
            //     this[arr[2]](arr[3]? arr[3] : '', arr[5]? arr[5] : '');
            // }
        },
        //发送表情消息
        sendEmojiMessage(index) {
            let message = this.createMessage(index, 'emoji')
            console.log(message)
            this.sendMessage(message);
        },
        //图片消息
        imgUploadSuccess(url) {
            let message = this.createMessage(url, 'img')
            console.log(message)
            this.sendMessage(message);
        },
        //语音消息
        voiceMessage(url, toId, content) {
            let message = this.createMessage(`${url}/time+${content}`, 'voice', toId)
            this.sendMessage(message);
        },
        definedMsgFN(msg, type = 'fn', to) {
            console.log(arguments)
            let message = this.createMessage(...arguments);
            this.sendMessage(message);
        },
        //教师查看当前程序
        handlerStuSaveWorks() {
            this.$emit('handlerStuSaveWorksFn')
        },
        handlerVoicePlay() {
            if(this.enableChat) {
                console.log(Recorder)
                Recorder.getPermission().then(() => {
                    this.input_speak = 'speak';
                    this.recorder.start().then(() => {
                        // 开始录音
                        console.log("开始录音")
                        this.interval = setInterval(() => {
                            this.voiceTime++
                            console.log(this.voiceTime)
                            if(this.voiceTime >= 15) {
                                this.handlerVoiceStop();
                                clearInterval(this.interval)
                            }
                        }, 1000)
                        this.speckLoadingPlay = true;
                    }, (error) => {
                        // 出错了
                        console.log(error);
                    });
                }, (error) => {
                    console.log(error);
                });
            }
        },
        handlerVoiceStop() {
            if(this.speckLoadingPlay && this.enableChat) {
                this.speckLoadingPlay = false;
                this.input_speak = 'input';
                clearInterval(this.interval)
                if(this.voiceTime >= 1) {
                    let data = this.recorder.getWAVBlob();
                    console.log(data)
                    let file = new window.File([data], 'voice.wav', {type: data.type})
                    console.log(file)
                    const form = new FormData();
                    form.append("file", file);
                    fileApi.upload(form, res => {
                        console.log(res)
                        if(res.data && !res.data.msg) {
                            this.voiceMessage(res.data, this.classData.teacherId, String(this.voiceTime))

                            // this.tic.sendTextMessage(this.teacherId, `/voice+${res.data}+${this.voiceTime}`);
                            this.voiceTime = 0;
                            this.$message({
                                message: '语音已发送',
                                type: 'success'
                            });
                        }
                    })
                } else {
                    this.recorder.stop();
                    this.voiceTime = 0;
                }
            }
        },
        //举手
        raiseHand() {
            this.definedMsgFN('raiseHand', 'fn', this.classData.teacherId, this.classData.userId)
        },
        startFileUpload() {
            // let params = {
            //     name: name,
            //     url: "",
            //     status: "uploading",
            // };
            // this.setClassData({
            //     ...this.classData,
            //     fileList: res.data.lessonFiles.concat([params])
            // })
        },
        setFileProgressBar() {

        },
        //文件消息
        fileUploadSuccess(url, name) {
            console.log(url, name);
            let filtContent = `${url}/name+${name}`
            let message = this.createMessage(filtContent, 'file')
            console.log(message)
            this.sendMessage(message);
        },
        definedMsg(msg, type = 'fn') {
            let message = this.createMessage(msg, type);
            this.sendMessage(message);
        },
        chatSwitchChange() {

        },
        sendTextMsg() {
            if(!this.msgContent) {
                return 
            }
            let message = this.createMessage(this.msgContent, 'text');
            this.sendMessage(message);
        },
        sendMessage(message) {
            this.msgContent = "";
            let promise = this.tim.sendMessage(message);
            console.log(message)
            promise.then((imResponse) => {
                // 发送成功
                console.log(imResponse);
                if(message.payload.description && message.payload.description != 'fn') {
                    this.msgs.push(message);
                    this.$nextTick(() => {
                        document.getElementById('msg_box').scrollTop = document.getElementById('msg_box').scrollHeight;
                    })
                }
            }).catch((imError) => {
                // 发送失败
                console.warn('sendMessage error:', imError);
            });
        },
        /***
         * msg 消息内容
         * type 消息类型
         * to 消息指向
         * content 消息携带信息
        */
        createMessage(msg, type, to = this.classData.channelId, content) {
            console.log(msg, type, to = this.classData.channelId, content)
            return this.tim.createCustomMessage({
                to,
                conversationType: to == this.classData.channelId? TIM.TYPES.CONV_GROUP : TIM.TYPES.CONV_C2C,
                // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
                // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
                // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
                payload: {
                    data: String(msg), //消息内容
                    description: type, //消息类型
                    extension: content? content : this.classData.userName //发送人姓名
                },
                // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
                // cloudCustomData: 'your cloud custom data'
            });
        },
        getMessageList() {
            // 打开某个会话时，第一次拉取消息列表
            let promise = this.tim.getMessageList({
                conversationID: `GROUP${this.classData.channelId}`, 
                count: 15
            });
            promise.then((imResponse) => {
                console.log(imResponse)
                this.msgs = imResponse.data.messageList;
                this.nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
                this.isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
                this.$nextTick(() => {
                    document.getElementById('msg_box').scrollTop = document.getElementById('msg_box').scrollHeight;
                })
            });
        },
        //查看更多消息
        viewMoreMsg() {
            // 下拉查看更多消息
            let promise = this.tim.getMessageList({
                conversationID:  `GROUP${this.classData.channelId}`, 
                nextReqMessageID:this.nextReqMessageID, 
                count: 15
            });
            promise.then((imResponse) => {
                console.log(imResponse)
                this.msgs.unshift(...imResponse.data.messageList);
                this.nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
                this.isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
            });
        },
        //处理消息
        checkEmojiMsg(text) {
            console.log(text)
            if(text.startsWith("/u+")) {
                return `<img src="${emoji[text.split("+")[1]].img}">`
            } else if(text.startsWith("/img+")) {
                return `<img style="max-width: 100%;" src="${text.split("+")[1]}">`
            } else if(text.startsWith("/voice+")) {
                return `<audio style="width: 200px;" src="${text.split("+")[1]}" controls="controls"></audio>`
            }
            return text;
        },
        showMessageInBox(fromUserId, text) {
            let textType = 'text';
            if(text.startsWith("/u+")) {
                textType = 'emoji';
            } else if(text.startsWith("/img+")) {
                textType = 'img';
            } else if(text.startsWith("/voice+")) {
                textType = 'voice';
            } else if(text.startsWith("/file+")) {
                textType = 'file';
            }
            tencentApi.findUserNameById(fromUserId, res => {
                if(res.succeed) {
                    let obj = {
                        // time: time,
                        send: res.data.name,
                        content: text,
                        userId: fromUserId,
                        type: textType
                    };
                    // var d = new Date();
                    // var time = `${('0' + d.getHours()).substr(-2)}:${('0' + d.getMinutes()).substr(-2)}:${('0' + d.getSeconds()).substr(-2)}`
                    this.msgs.push(obj);
                    console.log(this.msgs)
                    this.$nextTick(() => {
                        var msgbox = document.querySelector("#msg_box");
                        msgbox.scrollTop = msgbox.scrollHeight;
                    });
                    if(fromUserId == this.userLogin.userId && textType != 'voice' && textType != 'emoji') {
                        this.lessondata.chatRecord.push(obj);
                        localStorage.setItem('lessonInfo', JSON.stringify(this.lessondata));
                    }
                }
            })
        },
        handlerVoice(item) {
            console.log(item)
            console.log(this.$refs[item][0])
            console.log(this.$refs[item][0].duration)
            this.$refs[item][0].play();
        },
        //下载
        downloadFile(url) {
            let arr = url.split('/name+')
            this.$message({
                message: "正在下载中，请稍候"
            });
            fileApi.downLoad(arr[0], res => {
                this.downloadFileFun(res.data, arr[1]);
            });
        },
        //转换文件流
        downloadFileFun(data, name) {
            if (!data) {
                return;
            }
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
    },
}
</script>
<style scoped>
.functional_region {
    width: 100%;
    /* height: 100%; */
}
.functional_region.platformTrue {
    height: calc(100% - 360px);
}
.functional_region_tab {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 35px;
}
.functional_region_tab .functional_region_tab——item {
    flex: 1;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: var(--menuBg);
    font-size: 14px;
    background-color: #fff;
    border: 1px solid var(--menuBg);
    cursor: pointer;
}
.functional_region_tab .functional_region_tab——item.active {
    color: #fff;
    background-color: var(--menuBg);
}
.functional_region_foot_tab {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    user-select: none;
}
.foot_tab_box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.switchTitle {
    color: white;
    font-size: 13px;
}
.chatArea {
    position: relative;
    height: calc(100% - 95px);
    /* padding: 5px; */
    /* padding-bottom: 40px; */
    background-color: #F5F5F5;
    border: 1px solid var(--menuBg);
    border-radius: 3px;
}
.teaChatArea {
    height: calc(100% - 75px);
}
.im-log-box {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding-bottom: 5px;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
}
.im-log-box::-webkit-scrollbar {
    width: 3px;
}
.im-log-box::-webkit-scrollbar-thumb {
    width: 8px;
    height: 20px;
    background: #999aaa;
    border-radius: 3px;
}
.im-log-box li {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 5px 0;
    font-size: 14px;
    color: #666;
}
.im-log-box li.my {
    flex-direction: row-reverse;
}
.im-log-box .send {
    display: inline-block;
    width: 45px;
    height: 28px;
    line-height: 28px;
    text-align: right;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.im-log-box li.my .send {
    text-align: left;
}
.content {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    max-width: calc(100% - 50px);
    min-height: 28px;
    color: #000;
}
.triangleIcon {
    position: absolute;
    top: 10px;
    left: 2px;
    width: 8px;
    height: 8px;
    background-color: #fff;
    transform: rotate(45deg);
}
.mytriangleIcon {
    position: absolute;
    top: 10px;
    right: 2px;
    width: 8px;
    height: 8px;
    background-color: #95EC69;
    transform: rotate(45deg);
}
.contentBox {
    display: inline-block;
    /* max-width: calc(100% - 10px); */
    font-family: Arial, Helvetica, sans-serif;
    background-color: #95EC69;
    padding: 6px 10px;
    border-radius: 3px;
    margin: 0  5px;
    word-break: break-all;
}
.myContent {
    background-color: #fff;
}
.emojiImg {
    width: 30px;
}
.voiceIconImg {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 15px;
    cursor: pointer;
}
.voiceIconImg.my {
    flex-direction: row-reverse;
}
.voiceIconImg.my img {
    transform: rotate(180deg);
}

.voiceIconImg img {
    height: 100%;
    margin: 0 5px;
}
.commonBox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
.commonBox .el-button {
    padding: 18px 15px !important;
}
.hands_btn_box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 40px;
}
.hands_btn {
    display: block;
    width: 35px;
    height: 35px;
    background-color: #fff;
    border: 5px solid var(--menuHover);
    border-radius: 50%;
    cursor: pointer;
}
.hands_btn img {
    width: 35px;
    height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/chatArea.vue